import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import { productMainImage } from '@bluheadless/ui-logic/src/utils/product'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import { Grid, GridBottom } from './sidebar-bottom.styled'
import { useIntl } from 'react-intl'
import { AccordionTextGroup } from '../../../molecules/accordion'
import SocialShare from '../../../organisms/social-share'
import DynamicAreas from '../../../particles/dynamic-areas'
import RichContent from '../../../particles/rich-content'
import NeedHelp from './need-help'
import WashingIcons from '../../washing-icons'

const SidebarBottom = () => {
	const { formatMessage } = useIntl()
	const productContextValue = useProductContext()

	const {
		catalog: {
			products: {
				serviceInfo,
				needHelpLink: { enabled: needHelpLinkEnabled },
				sidebar: { accordion },
				imageType: { catalogBase },
				washingIcons: { enabled: washingIconsEnabled, attributeCode: washingIconsAttributeCode },
			},
		},
		socialShare: { enabled: enabledSocialShare },
	} = useConfig()

	const [
		{
			assets,
			inventory: { saleable },
			product: { sku, description, name, dynamicAreas, type, attributes },
		},
	] = productContextValue

	const mainAsset = productMainImage(assets, catalogBase)

	function parseDetails(string) {
		const values = string.split('|').filter((value) => value.trim() !== '')
		const list = values.map((value) => `<li>${value}</li>`).join('')
		return `<ul>${list}</ul>`
	}

	return (
		<>
			<DynamicAreas areas={dynamicAreas} container="top" />

			{accordion[type] && (
				<Grid>
					<AccordionTextGroup
						defaultExpanded="product.description"
						accordions={[
							description
								? {
										id: 'product.description',
										key: 'product.description',
										content: (
											<RichContent content={'<div>SKU: ' + sku + '</div><br /><div>' + description + '</div>'} />
										),
										title: formatMessage({ id: 'product_description' }),
										titleProps: {
											variant: 'body1',
										},
								  }
								: {},
						]
							?.concat(
								attributes['details']?.value?.length > 0 || attributes['taglie_e_misure']?.value?.length > 0
									? {
											id: 'product.details',
											key: 'product.details',
											content: (
												<RichContent
													content={
														(attributes['details']?.value?.length > 0
															? '<div>' + parseDetails(attributes['details'].value) + '</div>'
															: '') +
														(attributes['taglie_e_misure']?.value?.length > 0
															? '<div>' + attributes['taglie_e_misure'].value + '</div>'
															: '')
													}
												/>
											),
											title: formatMessage({ id: 'product_details' }),
											titleProps: {
												variant: 'body1',
											},
									  }
									: []
							)
							?.concat(
								attributes['composition']?.value?.length > 0 || attributes['washing_instructions']?.value?.length > 0
									? {
											id: 'product.composition_care',
											key: 'product.composition_care',
											content: (
												<RichContent
													content={
														(attributes['composition']?.value?.length > 0
															? '<div>' + attributes['composition'].value + '</div>'
															: '') +
														(attributes['washing_instructions']?.value?.length > 0
															? '<br /><div>' + attributes['washing_instructions'].value + '</div>'
															: '')
													}
												/>
											),
											title: formatMessage({ id: 'product_composition_care' }),
											titleProps: {
												variant: 'body1',
											},
									  }
									: []
							)
							?.concat(
								washingIconsEnabled &&
									washingIconsAttributeCode &&
									attributes[washingIconsAttributeCode]?.value?.length > 0
									? {
											id: 'product.washingIcons',
											key: 'product.washingIcons',
											content: <WashingIcons icons={attributes[washingIconsAttributeCode]?.value} />,
											title: formatMessage({ id: 'product_care' }),
											titleProps: {
												variant: 'body1',
											},
									  }
									: []
							)
							?.concat(
								saleable
									? serviceInfo
										? serviceInfo?.map(({ id, content, title }) => ({
												id: id,
												key: id,
												content: <RichContent content={content} />,
												title: title,
												titleProps: {
													variant: 'body1',
												},
										  }))
										: []
									: []
							)}
					/>
				</Grid>
			)}

			{needHelpLinkEnabled || enabledSocialShare ? (
				<GridBottom display="flex" justifyContent="space-between" alignItems="flex-start" mt={4}>
					<NeedHelp />
					<SocialShare title={name} media={mainAsset?.image ? mediaUrl(mainAsset?.image) : null} />
				</GridBottom>
			) : null}
		</>
	)
}

export default SidebarBottom
